function isNorthAmericanCountry(country) {
    return country === 'us' || country === 'ca';
}

export { isNorthAmericanCountry };
